import { BuildingUnitsListForm } from './building-units-list.form';
import { useLoadData } from '../../../hooks/useLoadData';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { ApiResponse } from '../../../models/api-response';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { Project, ProjectType } from '../../../models/project';
import { TimeAndMaterialEditForm } from './time-and-material-edit.form';
import { SactteredLoTEditForm } from './scattered-lot-edit.form';
import { stateApiKeyStore } from '../../../api/states-api-key-store';
import { useEffect, useState } from 'react';

interface EditProjectBuildingTabProps {
  project: Project;
}

export const EditProjectBuildingTab = ({ project }: EditProjectBuildingTabProps) => {
  const [scatteredSingleOrMultipleLot, setScatteredSingleOrMultipleLot] = useState<any>();
  const { isLoading, isFetching, data, refetch } = useLoadData<ApiResponse<any>>(
    projectsApiKeyStore.getProjectLotInfo(Number(project.projectID))
  );
  // const { data: states } = useLoadData<ApiResponse<any>>(stateApiKeyStore.getStates());
  // const { data: states } = useLoadData<ApiResponse<any>>(stateApiKeyStore.getStates());

  useEffect(() => {
    if (data?.data?.singleOrMultiLots?.length > 0) {
      const updatedData = data?.data?.singleOrMultiLots?.map((lot: any) => ({
        ...lot,
        stateID: !lot?.stateID ? null : { stateID: lot?.stateID },
        municipalityID: !lot?.municipalityID ? null : { municipalityID: lot?.municipalityID },
        // countyID: { countyID: lot?.countyID },
      }));

      setScatteredSingleOrMultipleLot(updatedData);
    }
  }, [data?.data]);

  if (isLoading || isFetching) {
    return <LoadingIndicator isLoading />;
  }

  if (project.projectType === ProjectType.TimeAndMaterial) {
    return (
      <TimeAndMaterialEditForm
        projectID={project.projectID}
        syncWithDux={project?.projectSyncWithDUX}
        singleOrMultiLots={data?.data.singleOrMultiLots}
        isTimeAndMaterial={true}
        refetch={refetch}
        page="project"
      />
    );
  }
  if (project.projectLotType === ProjectType.CommunityMultipleLot) {
    return (
      <TimeAndMaterialEditForm
        projectID={project.projectID}
        syncWithDux={project?.projectSyncWithDUX}
        singleOrMultiLots={data?.data.singleOrMultiLots}
        isTimeAndMaterial={false}
        refetch={refetch}
        page="project"
      />
    );
  }
  if (project.projectCommunityType === ProjectType.ResidentialSingleLot) {
    return (
      <TimeAndMaterialEditForm
        projectID={project.projectID}
        syncWithDux={project?.projectSyncWithDUX}
        singleOrMultiLots={data?.data.singleOrMultiLots}
        isTimeAndMaterial={false}
        refetch={refetch}
        page="project"
      />
    );
  }
  if (
    project.projectLotType === ProjectType.CommunityScatteredLot ||
    project?.projectCommunityType === ProjectType.CommunityScatteredLot
  ) {
    return (
      scatteredSingleOrMultipleLot && (
        <SactteredLoTEditForm
          projectID={project?.projectID}
          syncWithDux={project?.projectSyncWithDUX}
          singleOrMultiLots={scatteredSingleOrMultipleLot || []}
          isTimeAndMaterial={false}
          page="project"
        />
      )
    );
  }
  if (project.projectLotType === ProjectType.Buildings || project.projectCommunityType === ProjectType.Buildings) {
    return (
      <BuildingUnitsListForm
        page="project"
        projectID={project.projectID}
        syncWithDux={project?.projectSyncWithDUX}
        projectBuildings={data?.data.projectBuildings}
        refetch={refetch}
      />
    );
  }
  return <>No data to display</>;
};
